import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-effe9862"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card-container"
}
const _hoisted_2 = { class: "grid" }
const _hoisted_3 = { class: "col flex align-items-center mb-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "col-10 flex flex-column justify-content-center mb-2" }
const _hoisted_6 = { class: "font-normal m-0 overflow-hidden text-overflow-ellipsis white-space-nowrap" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "font-light" }
const _hoisted_9 = { class: "flex align-items-center mt-2 mb-1" }
const _hoisted_10 = { class: "col-12 border-top-1 border-200" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Internal error ")

import { toRefs } from "@vue/reactivity";
import CommentSection from "@/components/comment/CommentSection.vue";
import TagWrapper from "@/components/tag/TagWrapper.vue";
import BookmarkButton from "@/components/bookmark/BookmarkButton.vue";
import PostOptionButton from "@/components/post/PostOptionButton.vue";
import UserLink from "@/components/UserLink.vue";
import { useRoute } from "vue-router";
import { nlToBr } from "@/filters/nlToBrFilter";
import { useAuth0 } from "@auth0/auth0-vue";
import { Post } from "@/models/post";


export default /*#__PURE__*/_defineComponent({
  props: {
    post: null
  },
  emits: ["delete-click"],
  setup(__props: any, { emit }) {

const props = __props as {
  post: Post,
}



const { user } = useAuth0();
const postId = useRoute().params.id as string



const { post } = toRefs(props);

let domainName: string;
if (post.value) domainName = new URL(post.value.url).hostname;

return (_ctx: any,_cache: any) => {
  const _component_Card = _resolveComponent("Card")!
  const _component_Message = _resolveComponent("Message")!

  return (_unref(post))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Card, { class: "p-0" }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: `https://www.google.com/s2/favicons?sz=256&domain_url=${_unref(domainName)}`
                }, null, 8, _hoisted_4)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h3", _hoisted_6, [
                  _createElementVNode("a", {
                    href: _unref(post).url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    class: "no-underline"
                  }, _toDisplayString(_unref(post).title ? _unref(post).title : _unref(post).url), 9, _hoisted_7)
                ]),
                _createElementVNode("small", _hoisted_8, [
                  _createVNode(UserLink, {
                    username: _unref(post).user.username,
                    id: _unref(post).user.id,
                    class: "font-semibold"
                  }, null, 8, ["username", "id"]),
                  _createTextVNode(" - " + _toDisplayString(new Date(_unref(post).created_at.replace(" ", "T")).toLocaleDateString()), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(BookmarkButton, {
                    bookmarked: _unref(post).bookmarks.length !== 0,
                    uuid: _unref(post).uuid
                  }, null, 8, ["bookmarked", "uuid"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(post).post_tags, (tags) => {
                    return (_openBlock(), _createBlock(TagWrapper, {
                      key: tags.uuid,
                      class: "ml-2",
                      value: tags.tag.name
                    }, null, 8, ["value"]))
                  }), 128))
                ])
              ]),
              (_unref(post).user.id === _unref(user).sub)
                ? (_openBlock(), _createBlock(PostOptionButton, {
                    key: 0,
                    class: "col",
                    postId: _unref(postId),
                    onDeleteClick: _cache[0] || (_cache[0] = ($event: any) => (emit('delete-click')))
                  }, null, 8, ["postId"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", {
                  class: "pt-0 pb-0 overflow-auto text-justify",
                  innerHTML: 
              _unref(post).description
                ? _unref(nlToBr)(_unref(post).description).value
                : '<i>No description</i>'
            
                }, null, 8, _hoisted_11)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(CommentSection, { postId: _unref(postId) }, null, 8, ["postId"])
              ])
            ])
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createBlock(_component_Message, {
        key: 1,
        class: "mt-5",
        severity: "error"
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      }))
}
}

})